import { Component } from 'react';
import { MdWarningAmber, MdRefresh, MdHome } from 'react-icons/md';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[ErrorBoundary] Caught error:', error, info.componentStack);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-6">
        <div className="text-center max-w-sm w-full">
          <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <MdWarningAmber className="text-red-400 text-3xl" />
          </div>
          <h1 className="text-lg font-bold text-secondary mb-2">Something went wrong</h1>
          <p className="text-sm text-gray-400 mb-6 leading-relaxed">
            Please refresh the page. If the issue continues, contact TrainAxis support.
          </p>
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={() => window.location.reload()}
              className="flex items-center gap-1.5 px-4 py-2 bg-primary text-white text-sm font-semibold rounded-xl hover:bg-red-600 transition-colors"
            >
              <MdRefresh /> Refresh Page
            </button>
            <a
              href="/"
              className="flex items-center gap-1.5 px-4 py-2 border border-gray-200 text-sm font-medium rounded-xl text-gray-500 hover:bg-gray-50 transition-colors"
            >
              <MdHome /> Go Home
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
